module.exports = __webpack_public_path__ + "img/commodity-001.12b5b909.png";